import { defineStore } from 'pinia';
import type { GuaranteeActionState } from '~~/types/vuex/GuaranteeAction';

export const isGuaranteeActionBeingClickedStore = defineStore('isGuaranteeActionBeingClicked', {
  state: () => ({ isGuaranteeActionBeingClicked: false as GuaranteeActionState['isGuaranteeActionBeingClicked'] | null }),
  actions: {
    setIsGuaranteeActionBeingClicked(payload: GuaranteeActionState['isGuaranteeActionBeingClicked'] | null) {

      this.isGuaranteeActionBeingClicked = payload; 

    },
  },
});
